import styled from 'styled-components'
import { rem, transitions } from 'polished'

import theme from 'styles/theme'
import { Title20 } from 'components/Typography'
import { ChevronIcon } from 'components/Icons'

const SelectItemStyle = `
  border: 1px solid ${theme.colors.gray};
  padding: ${rem(15)} ${rem(20.8)};
  background: transparent;

  ${theme.mediaQueries.medium} {
    padding: ${rem(10.63)} ${rem(20.63)};
  }
`

export const Wrapper = styled.div`
  position: relative;
`

export const SelectBase = styled.div`
  position: relative;
  display: block;
`

export const SelectButton = styled.button`
  ${transitions('background-color 0.3s', 'color 0.3s')}
  ${SelectItemStyle}
  font-family: BrownStd-Light;
  position: relative;
  background-color: ${theme.colors.white};
  color: ${theme.colors.darkGrey};
  width: 100%;
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;

  &:active,
  &:hover {
    background-color: ${theme.colors.darkGrey};
    color: ${theme.colors.white};

    path {
      fill: ${theme.colors.white};
    }
  }
`

export const SimpleWrapper = styled.div`
  position: relative;
  display: flex;
  flex-flow: column nowrap;
  align-self: center;
  width: 100%;
  padding: 0px 20px;
  padding-bottom: 24px;

  ${theme.mediaQueries.medium} {
    width: initial;
    ${(props) => props.minWidth && `min-width: ${rem(props.minWidth)};`}
  }
`

export const SelectList = styled.div`
  ${transitions('opacity 0.3s')}
  height: 0px;
  opacity: 0;
  position: absolute;
  top: 100%;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  flex-flow: column nowrap;
  justify-content: stretch;
  z-index: 2;
  width: max-content;
  row-gap: 13px;
  overflow: hidden;

  & > *:first-child {
    margin-top: 13px;
  }

  & > *:last-child {
    box-shadow: 0px 6px 7.84px -3px rgba(211, 218, 226, 1);
  }

  &::after {
    content: '';
    display: block;
    width: 100%;
    position: absolute;
    height: 100%;
    transform: scale(0.9);
    left: 0;
    top: 0;
    background-color: ${theme.colors.white};
    z-index: -1;
    box-shadow: 0px 0px 10px 10px ${theme.colors.white};
  }

  ${(props) =>
    props?.open &&
    `
    height: auto;
    opacity: 1;
  `}
`

export const SimpleSelectBase = styled.select`
  ${SelectItemStyle}
  padding: ${rem(8)} ${rem(12)};
  font-family: BrownStd-Light, sans-serif;
`

export const SimpleLabel = styled(Title20)`
  display: flex;
  flex-direction: row;
  column-gap: 8px;
  align-items: center;
  justify-content: center;
  width: 100%;
  text-align: center;
  font-size: ${rem(20)};
  padding-top: ${rem(12)};
  padding-bottom: ${rem(26)};

  ${theme.mediaQueries.medium} {
    font-size: ${rem(24)};
    padding-bottom: ${rem(20)};
    padding-top: ${rem(16)};
  }
`

export const ListWrapper = styled.div`
  position: relative;
  width: 100%:
`

export const DropdownIcon = styled(ChevronIcon)`
  ${transitions('transform 0.5s')}
  transform: rotateZ(-90deg) rotateY(${(props) => (props.open ? -180 : 0)}deg);
`
